import script from "./GameMomentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./GameMomentPanel.vue?vue&type=script&setup=true&lang=js"

import "./GameMomentPanel.vue?vue&type=style&index=0&id=0b1b8af1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1b8af1"]])

export default __exports__